import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment, Funzioni, IFunzioniLng } from '../../models/-index';

import { CrudGenericsService } from '../common/crud-generics';
import { Observable } from 'rxjs';

@Injectable()
export class FunzioniService extends CrudGenericsService<Funzioni, string> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Funzioni`);
    this.base = `${env.apiUrl}/api/Funzioni/`;
  }
  GetAll_FunzioniLng(): Observable<IFunzioniLng[]> {
    const url = this.base + 'GetAll_FunzioniLng';
    return this.http.get<IFunzioniLng[]>(`${url}`);
  }
}
